import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Prenota from "./pages/Prenota";
import Regalo from "./pages/Regalo";
import Info from "./pages/Info";
import Privacy from "./pages/Privacy";
import CookiePolicy from "./pages/Cookie";
import Termini from "./pages/Termini";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/prenota" element={<Prenota />} />
          <Route path="/regalo" element={<Regalo />} />
          <Route path="/info" element={<Info />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
